import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', name: 'dashboard', component: () => import('./pages/DashboardPage.vue') },
    { path: '/evidence', name: 'evidence', component: () => import('./pages/EvidencePage.vue') },
    { path: '/review', name: 'review', component: () => import('./pages/ReviewPage.vue') },
    { path: '/settings', name: 'settings', component: () => import('./pages/SettingsPage.vue') }
  ]
})

export default router
